import React from "react";
import Box from "@mui/material/Box";
import Tab from "@mui/material/Tab";
import TabContext from "@mui/lab/TabContext";
import TabPanel from "@mui/lab/TabPanel";
import { useTheme } from "@emotion/react";
import TabsCustom from "src/shared/components/tabs/TabsCustom";
import { Container } from "@mui/material";
import MyReservations from "./MyReservations";
import { useRecoilState, useRecoilValue, useSetRecoilState } from "recoil";
import {
  activeTabReservationsPatientState,
  showModalCancelReservationState,
} from "./state/atoms";
import ListHistoryReservations from "./components/ListHistoryReservations";
import ListViewerExams from "./components/ListViewerExams";
import ListViewerExamsLab from "./components/ListViewerExamsLab";

import {
  reservationsHistoryState,
  reservationsRecentsState,
  viewerExamsState,
  viewerExamsLabState,
} from "../state/atoms";
import ModalCancelReservation from "./components/ModalCancelReservation";
import useSEO from "src/Hooks/useSEO";
import ListClinicalHistory from "../historialClinico/ListClinicalHistory";
import ClinicalHistoryView from "../historialClinico/ClinicalHistoryView";

export default function TabsReservationsPatient() {
  const [activeTabReservationsPatient, setActiveTabReservationsPatient] =
    useRecoilState(activeTabReservationsPatientState);
  const setReservationsRecents = useSetRecoilState(reservationsRecentsState);
  const setReservationsHistory = useSetRecoilState(reservationsHistoryState);
  const setViewerExamsHistory = useSetRecoilState(viewerExamsState);
  const setViewerExamsLab = useSetRecoilState(viewerExamsLabState);
  const theme = useTheme();
  const showModalCancelReservation = useRecoilValue(
    showModalCancelReservationState
  );

  useSEO({ title: "Mis reservas" });

  const handleChange = (event, newValue) => {
    setReservationsRecents([]);
    setReservationsHistory([]);
    setViewerExamsHistory([]);
    setViewerExamsLab([]);
    setActiveTabReservationsPatient(newValue);
  };

  return (
    <Container disableGutters>
      {showModalCancelReservation && <ModalCancelReservation />}
      <Box sx={{ width: "100%", typography: "body1" }}>
        <TabContext value={activeTabReservationsPatient}>
          <Box
            sx={{ position: "sticky", top: "63px", zIndex: 20, width: "100%" }}
          >
            <Box
              sx={{
                position: "relative",
                left: "-16px",
                right: "-16px",
                width: "calc(100% + 32px)",
              }}
            >
              <TabsCustom
                theme={theme}
                onChange={handleChange}
                aria-label="lab API tabs example"
                variant="scrollable"
                scrollButtons
                allowScrollButtonsMobile
                sx={{ width: "100%" }}
              >
                <Tab
                  sx={{ paddingLeft: { xs: 0, md: 2 } }}
                  label="Mis reservas"
                  value="1"
                />
                <Tab label="Historial " value="2" />
                <Tab label="Imagenología" value="3" />
                <Tab
                  sx={{ paddingRight: { xs: 0, md: 2 } }}
                  label="Exámenes Laboratorio"
                  value="4"
                />
              </TabsCustom>
            </Box>
          </Box>
          <TabPanel value="1" style={{ paddingLeft: 0, paddingRight: 0 }}>
            <MyReservations />
          </TabPanel>
          <TabPanel value="2" style={{ paddingLeft: 0, paddingRight: 0 }}>
            <ClinicalHistoryView />
          </TabPanel>
          <TabPanel value="3" style={{ paddingLeft: 0, paddingRight: 0 }}>
            <ListViewerExams />
          </TabPanel>
          <TabPanel value="4" style={{ paddingLeft: 0, paddingRight: 0 }}>
            <ListViewerExamsLab />
          </TabPanel>
        </TabContext>
      </Box>
    </Container>
  );
}
